import {BaseService} from './BaseService';
export default class DashboardService extends BaseService {
  getEnterprisingCount() {
    return this.fetch(`${this.domain}/dashboard/enterprising/count`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }

  getIncubationProjectsCount() {
    return this.fetch(`${this.domain}/dashboard/projects/incubation/count`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }

  getAnnouncementsCount() {
    return this.fetch(`${this.domain}/dashboard/announcements/count`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }

  getAnnouncementsUNCLinkedCount() {
    return this.fetch(`${this.domain}/dashboard/announcements/unclinked/count`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }

  getProjectsByStatus() {
    return this.fetch(`${this.domain}/dashboard/projects/bystatus`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }
  getHoursByATG() {
    return this.fetch(`${this.domain}/dashboard/atg/hours`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }

  getProjectsByYearStatus() {
    return this.fetch(`${this.domain}/dashboard/projects/byyear`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }

  getEmprendedoresXConvocatoria() {
    return this.fetch(`${this.domain}/dashboard/enterprising/byannouncements`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }

}



// WEBPACK FOOTER //
// ./src/services/DashboardService.js